import { useSyncExternalStore } from "react";
export function useMediaQuery(query) {
    return useSyncExternalStore((cb) => {
        const m = window.matchMedia(query);
        m.addEventListener("change", cb);
        return () => m.removeEventListener("change", cb);
    }, () => window.matchMedia(query).matches);
}
